/**
 * /v1/search/temp 响应里 uid 常为超过 JS 安全整数的大数，需在 JSON.parse 前转为字符串。
 */
export function parseSearchTempResponse(data) {
	if (typeof data !== "string") return data;

	try {
		const fixed = data.replace(/"uid"\s*:\s*(\d{15,})/g, '"uid":"$1"');
		return JSON.parse(fixed);
	} catch {
		return JSON.parse(data);
	}
}

export function getSearchTeacherUid(item) {
	const uid = item?.uid;
	if (uid === undefined || uid === null || String(uid).trim() === "") return "";
	return String(uid);
}
